document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('.product-form__swatch__item--color input[type="radio"]')
    .forEach((colorInput) => {
      if (colorInput.checked) selectColorVariant(colorInput.value);

      colorInput.addEventListener("change", () => {
        if (colorInput.checked) selectColorVariant(colorInput.value);
      });
    });

  function selectColorVariant(color) {
    // define selected color variant thumbnails
    document
      .querySelectorAll(".thumbnail-list .media-gallery__thumb-image")
      .forEach((productThumbnail) => {
        if (
          productThumbnail.getAttribute("alt").trim().toLowerCase() ===
          color.trim().toLowerCase()
        ) {
          productThumbnail.closest(".thumbnail-list__item").style.display =
            "block";
          productThumbnail
            .closest(".thumbnail-list__item")
            .classList.toggle("include-thumb", true);
        } else {
          productThumbnail.closest(".thumbnail-list__item").style.display =
            "none";
          productThumbnail
            .closest(".thumbnail-list__item")
            .classList.toggle("include-thumb", false);
        }
      });
  }
});
